/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc } from '../../../main-routes/my-organisation/OrganisationSettingsOfferedServices.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CategoryProjectTypeMappingFieldsFragment = { __typename: 'CategoryProjectTypeMapping', categoryId: string, projectType: Types.ProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null };

export type EditOverridesModal_CategoryGlobalMappingsQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
}>;


export type EditOverridesModal_CategoryGlobalMappingsQuery = { categories: Array<{ __typename: 'Category', id: string, projectTypeMappings: Array<{ __typename: 'CategoryProjectTypeMapping', categoryId: string, projectType: Types.ProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null }> }> };

export type EditOverridesModal_TemplatesByIdsQueryVariables = Types.Exact<{
  templateIds: Array<Types.Scalars['ID']['input']>;
}>;


export type EditOverridesModal_TemplatesByIdsQuery = { searchTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string } }> } };

export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables = Types.Exact<{
  input: Types.UpsertOrganisationCategoryProjectTypeMappingOverrideInput;
}>;


export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutation = { upsertOrganisationCategoryProjectTypeMappingOverride: { __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null } };

export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationCategoryProjectTypeMappingOverrideInput;
}>;


export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutation = { deleteOrganisationCategoryProjectTypeMappingOverride: { __typename: 'DeleteOrganisationCategoryProjectTypeMappingOverridePayload', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType } };

export const CategoryProjectTypeMappingFieldsFragmentDoc = gql`
    fragment CategoryProjectTypeMappingFields on CategoryProjectTypeMapping {
  categoryId
  projectType
  defaultTemplateId
  defaultSmartProcess
}
    `;
export const EditOverridesModal_CategoryGlobalMappingsDocument = gql`
    query EditOverridesModal_CategoryGlobalMappings($categoryId: ID!) {
  categories(ids: [$categoryId]) {
    id
    projectTypeMappings {
      ...CategoryProjectTypeMappingFields
    }
  }
}
    ${CategoryProjectTypeMappingFieldsFragmentDoc}`;

/**
 * __useEditOverridesModal_CategoryGlobalMappingsQuery__
 *
 * To run a query within a React component, call `useEditOverridesModal_CategoryGlobalMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOverridesModal_CategoryGlobalMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOverridesModal_CategoryGlobalMappingsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useEditOverridesModal_CategoryGlobalMappingsQuery(baseOptions: Apollo.QueryHookOptions<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables> & ({ variables: EditOverridesModal_CategoryGlobalMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>(EditOverridesModal_CategoryGlobalMappingsDocument, options);
      }
export function useEditOverridesModal_CategoryGlobalMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>(EditOverridesModal_CategoryGlobalMappingsDocument, options);
        }
export function useEditOverridesModal_CategoryGlobalMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>(EditOverridesModal_CategoryGlobalMappingsDocument, options);
        }
export type EditOverridesModal_CategoryGlobalMappingsQueryHookResult = ReturnType<typeof useEditOverridesModal_CategoryGlobalMappingsQuery>;
export type EditOverridesModal_CategoryGlobalMappingsLazyQueryHookResult = ReturnType<typeof useEditOverridesModal_CategoryGlobalMappingsLazyQuery>;
export type EditOverridesModal_CategoryGlobalMappingsSuspenseQueryHookResult = ReturnType<typeof useEditOverridesModal_CategoryGlobalMappingsSuspenseQuery>;
export type EditOverridesModal_CategoryGlobalMappingsQueryResult = Apollo.QueryResult<EditOverridesModal_CategoryGlobalMappingsQuery, EditOverridesModal_CategoryGlobalMappingsQueryVariables>;
export const EditOverridesModal_TemplatesByIdsDocument = gql`
    query EditOverridesModal_TemplatesByIds($templateIds: [ID!]!) {
  searchTemplates(filters: {templateIds: $templateIds}, limit: 100) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          title
        }
      }
    }
  }
}
    `;

/**
 * __useEditOverridesModal_TemplatesByIdsQuery__
 *
 * To run a query within a React component, call `useEditOverridesModal_TemplatesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOverridesModal_TemplatesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOverridesModal_TemplatesByIdsQuery({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useEditOverridesModal_TemplatesByIdsQuery(baseOptions: Apollo.QueryHookOptions<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables> & ({ variables: EditOverridesModal_TemplatesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>(EditOverridesModal_TemplatesByIdsDocument, options);
      }
export function useEditOverridesModal_TemplatesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>(EditOverridesModal_TemplatesByIdsDocument, options);
        }
export function useEditOverridesModal_TemplatesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>(EditOverridesModal_TemplatesByIdsDocument, options);
        }
export type EditOverridesModal_TemplatesByIdsQueryHookResult = ReturnType<typeof useEditOverridesModal_TemplatesByIdsQuery>;
export type EditOverridesModal_TemplatesByIdsLazyQueryHookResult = ReturnType<typeof useEditOverridesModal_TemplatesByIdsLazyQuery>;
export type EditOverridesModal_TemplatesByIdsSuspenseQueryHookResult = ReturnType<typeof useEditOverridesModal_TemplatesByIdsSuspenseQuery>;
export type EditOverridesModal_TemplatesByIdsQueryResult = Apollo.QueryResult<EditOverridesModal_TemplatesByIdsQuery, EditOverridesModal_TemplatesByIdsQueryVariables>;
export const UpsertOrganisationCategoryProjectTypeMappingOverrideDocument = gql`
    mutation UpsertOrganisationCategoryProjectTypeMappingOverride($input: UpsertOrganisationCategoryProjectTypeMappingOverrideInput!) {
  upsertOrganisationCategoryProjectTypeMappingOverride(input: $input) {
    ...OrganisationCategoryProjectTypeMappingOverrideFields
  }
}
    ${OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc}`;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationFn = Apollo.MutationFunction<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;

/**
 * __useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation__
 *
 * To run a mutation, you first call `useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganisationCategoryProjectTypeMappingOverrideMutation, { data, loading, error }] = useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>(UpsertOrganisationCategoryProjectTypeMappingOverrideDocument, options);
      }
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationHookResult = ReturnType<typeof useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationResult = Apollo.MutationResult<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationOptions = Apollo.BaseMutationOptions<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;
export const DeleteOrganisationCategoryProjectTypeMappingOverrideDocument = gql`
    mutation DeleteOrganisationCategoryProjectTypeMappingOverride($input: DeleteOrganisationCategoryProjectTypeMappingOverrideInput!) {
  deleteOrganisationCategoryProjectTypeMappingOverride(input: $input) {
    organisationId
    categoryId
    projectType
  }
}
    `;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationFn = Apollo.MutationFunction<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;

/**
 * __useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationCategoryProjectTypeMappingOverrideMutation, { data, loading, error }] = useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>(DeleteOrganisationCategoryProjectTypeMappingOverrideDocument, options);
      }
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationHookResult = ReturnType<typeof useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationResult = Apollo.MutationResult<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;